export function formatPhoneNumber(originalNumber: number | string) {
  const stripped = String(originalNumber).match(/\d/g);

  return `(${stripped?.slice(0, 3).join("")}) ${stripped?.slice(3, 6).join("")}-${stripped
    ?.slice(6)
    .join("")}`;
}
